// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_LANGUAGE = 'language/SET_LANGUAGE';
